import URL from '@/tools/url';
import jquery from 'jquery';
import _forIn from 'lodash/forIn';
import _toFinite from 'lodash/toFinite';

/**
 * @description
 * Обновление состава корзины.
 * Позволяет:
 * - обновить состав корзины
 * - удалить несколько позиций
 * - добавить несколько позиций
 * - изменить кол-во товаров позиции
 * - установить комментарии к позициям
 *
 * @param {Object} items - набор пар {variant_id: quantity, ...}. Если quantity = 0, то позиция удаляется из корзины, в противном случае устанавливается указанное кол-во
 * @param {Object} options - дополнительные поля: comments, coupon
 * @param {Object} options.comments - объект с комментариями вида {variant_id: comment, ...}
 * @param {String} options.coupon - название купона
 *
 * @return {$.ajax} Ajax запрос к корзине
 *
 * @example
 * var items = {
 *   123456: 1,
 *   123457: 3,
 *   123450: 100
 * };
 *
 * var options = {
 *   comments: { 123456: 'Ваш комментарий' },
 *   coupon: 'test'
 * }
 *
 * ajaxAPI.cart.update(items, optins)
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function(items, options) {
  var _lang = URL.getKeyValue('lang') || '';
  var fields = {
    lang: _lang,
    _method: 'put'
  };
  var _options = options || {};

  _forIn(items, function(quantity, variant_id) {
    fields['cart[quantity][' + variant_id + ']'] = _toFinite(quantity);
  });

  if (_options.comments) {
    _forIn(_options.comments, function(comment, variant_id) {
      var item = window.InsalesCommonCart.order.getItemByID(variant_id);
      var thisComment = (item) ? item.comment : '';
      if (window.InsalesCommonCart.order.getItemByID(variant_id) && thisComment !== comment) {
        fields['cart[order_line_comments][' + variant_id + ']'] = comment;
      } else if (!item) {
        fields['cart[order_line_comments][' + variant_id + ']'] = comment;
      }
    });
  }

  if (_options.coupon) {
    fields['cart[coupon]'] = _options.coupon;
  }

  return jquery.post('/cart_items/v2.json', fields);
}
